import { memo } from 'react';
import { cx } from '@emotion/css';

import type { ChipProps as MuiChipProps } from '@mui/material';
import { Chip as MuiChip } from '@mui/material';

import cn from './chip.module.scss';

//[Link to Figma](https://www.figma.com/design/haLJY8Z5UGGqIbRajgg9GP/Design-system?node-id=2271-22913&node-type=frame&t=ribwKhhlVK1mbX6y-0)

type ChipProps = MuiChipProps & {
    severity?: 'info' | 'warning' | 'error' | 'success' | 'highlight' | 'neutral';
}
const Chip = ({ severity, disabled, onClick, className, ...props }: ChipProps) => {
    return (
        <MuiChip
            className={cx(
                cn.container,
                severity && cn[severity],
                disabled && cn.disabled,
                onClick && cn.clickable,
                className
            )}
            disabled={disabled}
            onClick={onClick}
            {...props}
        />
    );
};

export default memo(Chip);
